<template>
<div class="container">
    <div class="common-header-wrap">
        <mt-header title="Feedback" class="common-header">
            <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
    </div>
    <div class="feedback-form mb-5">
        <mt-field label="Feedback content" v-model="feedback" type="textarea"></mt-field>

        <mt-field label="Verification code" v-model="pictureCode">
            <img @click="changePictureCode" height="48" :src="pictureCodeUrl" class="countdown" >
        </mt-field>
        <mt-button class="ds-button-large" type="primary" v-on:click="submit">Save</mt-button>
    </div>
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
        <div v-if="feedback_list && feedback_list.length">
            <div class="feedback-item"  v-for="(item, index) in feedback_list">
                <div class="feedback-info">
                    <div class="p-info">
                        <div class="explain">Consultation content
                            <span class="right">{{ $moment.unix(item.fb_time).format('YYYY-MM-DD') }}</span>
                        </div>
                        <div class="name">{{item.fb_content}}</div>
                    </div>
                </div>
            </div>
        </div>
        <empty-record v-else-if="feedback_list && !feedback_list.length"></empty-record>
    </div>
</div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import EmptyRecord from '../../../components/EmptyRecord'
import { getFeedbackList, addFeedback } from '../../../api/memberFeedback'
import { checkPictureCaptcha } from '../../../api/common'
export default {
  name: 'MemberFeedback',
  data () {
    return {
      feedback: '',
      params: { 'page': 0, 'per_page': 10 },
      pictureCode: '',
      pictureCodeUrl: '',
      pictureCodeValid: false,
      feedback_list: false,
      loading: false, // 是否加载更多
      isMore: true // 是否有更多
    }
  },
  components: {
    EmptyRecord
  },
  mounted () {
    this.changePictureCode()
  },
  created () {

  },
  watch: {
    pictureCode: function (val) {
      if (val.length >= 4) {
        this.pictureCodeWait = true
        checkPictureCaptcha(val).then(
          response => {
            this.pictureCodeWait = false
            this.pictureCodeValid = true
          },
          error => {
            this.pictureCodeWait = false
            Toast(error.message)
          }
        )
      }
    }
  },
  methods: {
    submit () {
      if (!this.pictureCode) {
        Toast('Please enter the image verification code first')
        return
      }
      if (!this.feedback) {
        Toast('Please enter the feedback content first')
        return
      }
      if (!this.pictureCodeValid) {
        Toast('Verification code error')
        return
      }
      addFeedback(this.feedback).then(res => {
        Toast(res.message)
        this.feedback = ''
        this.pictureCode = ''
        this.params = { 'page': 0, 'per_page': 10 }
        this.feedback_list = false
        this.loading = false
        this.isMore = true
        this.loadMore()
        this.changePictureCode()
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    changePictureCode () {
      this.pictureCodeUrl = env.API_HOST + '/Seccode/makecode?r=' + Math.random()
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getConsultList(true)
      }
    },
    getConsultList () {
      Indicator.open()
      getFeedbackList(this.params).then(res => {
        Indicator.close()
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
        this.feedback_list = res.result.feedback_list.data
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    }
  }

}
</script>

<style scoped lang="scss">
    .feedback-item{background:#fff;border-bottom:1px solid #e1e1e1}
    .feedback-info{padding:.5rem;display: flex}
    .feedback-info .p-info{flex:1;margin-left:1rem;}
    .feedback-info .p-info .name{font-size:0.7rem;}
    .feedback-info .p-info .explain{font-size:0.7rem;color:$primaryColor;margin-bottom:.5rem}
    .feedback-info .p-info .explain .right{float:right;color:gray}
    .feedback-info .p-info .replay{border-top:1px dashed #e1e1e1;font-size:.8rem;margin-top:.5rem;padding-top:.5rem;color:green}
</style>
